export const SET_GLOBAL_CONFIGURATION = "@KENTA:SET_GLOBAL_CONFIGURATION";
